// Static display strings for site-wide stats. Update here and all usages
// pick up the change at build time (FAQ, meta descriptions, hero fallback text).
// The live total in the hero chip is fetched from catalog-facets and animated;
// these constants serve as fallbacks and for non-animated surfaces.

export const STAT_LISTINGS = "16 mil+";
export const STAT_SOURCES = "60+";
